class FilterablePagination {

    constructor(element, params = {}) {

        if (typeof element == 'undefined' ||
            typeof element.data('filters') === 'undefined') {
            return;
        }

        this.element = element;
        this.type = this.element.data('type');
        this.searchbar = $(this.element.data('filters'));

        this.xhr;

        this.resetToFirstPage = false;

        this.textNoResults = '';
        if (typeof this.element.data('no-results') != 'undefined') {
            this.textNoResults = this.element.data('no-results');
        }

        this.searchbar.find('.filter-datepicker').datepicker({
            dateFormat: 'dd-mm-yy',
            showWeek: true,
            firstDay: 1,
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true
        });

        this.searchbar.find('input.filter-datepicker:data(sibling)[data-operator^=">"]').each(function() {
            if ($(this).val() != '') {
                let date = $(this).val().split('-');
                $(this).datepicker('setDate', new Date(date[2], date[1] - 1, date[0]));
            }
        });

        this.searchbar.find('input.filter-datepicker:data(sibling)[data-operator^="<"]').each(function() {
            if ($(this).val() != '') {
                let date = $(this).val().split('-');
                $(this).datepicker('setDate', new Date(date[2], date[1] - 1, date[0]));
            }
        });

        // By default, order by created at DESC (asc = false)
        this.orderBy = [
            'created_at', // column 
            false // ascending when true
        ];
        if(!!this.element.data('orderby')){
            this.orderBy = this.element.data('orderby').split('|');
            this.orderBy[1] = this.orderBy[1] == 'true' ? true : false;
        }
        
        this.element.find('[data-column="'+this.orderBy[0]+'"]').addClass('sort-'+(this.orderBy[1] ? 'asc' : 'desc'));
        this.getData();

        this.events();
    }

    events() {

        let self = this;

        this.searchbar.find('form').on("keypress", function(e) {
            let code = e.keyCode || e.which;
            if (code == 13) {
                preventDefault(e);
                return false;
            }
        });

        this.element.on('click', '.header *[data-column]', function() {

            // Same column? Switch order
            if(self.orderBy[0] == $(this).data('column')){
                self.orderBy[1] = !self.orderBy[1];
            }
            // Else set column with default order 
            else {
                self.orderBy = [
                    $(this).data('column'),
                    false
                ];
            }

            $(this).parent().find('.sort-asc, .sort-desc').removeClass('sort-asc sort-desc');
            $(this).addClass('sort-'+(self.orderBy[1] ? 'asc' : 'desc'));
            
            
            self.filter();
        });

        this.searchbar.find('select.filter-input, input.filter-datepicker').on('change', function() {

            self.resetToFirstPage = true;

            self.filter();
        });

        this.searchbar.find('input.filter-input:not(.filter-datepicker)').on('keyup paste', function() {
            self.resetToFirstPage = true;
            self.filter();
        });

        this.searchbar.find('input.filter-datepicker:data(sibling)[data-operator^=">"]').on('change', function() {
            $('#'+$(this).data('sibling')).datepicker('option', 'minDate', $(this).datepicker('getDate'));
        });

        this.searchbar.find('input.filter-datepicker:data(sibling)[data-operator^="<"]').on('change', function() {
            $('#'+$(this).data('sibling')).datepicker('option', 'maxDate', $(this).datepicker('getDate'));
        });

        this.searchbar.find('.btn-reset').on('click', function() {
        
            self.searchbar.find('.filter-input').each(function() {
                
                if ($(this).is("input:not(.filter-datepicker)")) {
                    $(this).val('');
                }  

                if ($(this).is("select")) {
                    $(this).val($(this).data('default-selected'));
                }   

                if ($(this).is("input.filter-datepicker")) {
                    $(this).datepicker('setDate', null);
                }
            });

            self.getOverviewData('filters', {
                'reset': true
            });
        });


        $(document).on('change', '.rows-per-page', function(e) {

            e.stopPropagation();

            self.getOverviewData(
                'items_per_page', 
                $(this).selectpicker('val')
            );
        });

        $(document).on('click', '.pagination .page-item', function(e) {

            e.stopPropagation();

            $(this).closest('.pagination').find('.page-item').removeClass('active');
            $(this).addClass('active');

            self.getOverviewData(
                'page_current',
                $(this).data('page')
            );
        });
        
    }


    setVisibility() {
        // $('.overview').each(function() {

        if (this.element.find('.body .row-item').length > 0) {
            this.element.find('.header').show();
            this.element.find('.pagination-toolbar').show();
            this.element.find('.no-data').hide();
            this.element.add('.pagination-toolbar select').selectpicker('render');
        } else {
            this.element.find('.header').hide();
            this.element.find('.pagination-toolbar').hide();
            this.element.find('.no-data')
                .removeClass('d-none')
                .show();
        }
        // });
    }

    getOverviewData(type, data) {
        
        const self = this;

        if (typeof self.xhr !== 'undefined') {
            self.xhr.abort();
        }

        let args = {
            dir: self.element.data('type'),
            orderBy: self.orderBy
        };

        if(self.resetToFirstPage){
            args['page_current'] = 1;
        }

        args[type] = data;

        let additionalOverview = false
        if ($('.additional-overview').length !== 0) {
            additionalOverview = true;
        }
    
        setLoading('.overview', 'add');
        if(additionalOverview) setLoading('.additional-overview', 'add');

        self.xhr = $.ajax({
            url: window.location.href,
            type: 'get',
            data: args,
            success: function(response) {
            
                let html = $(response);
    
                // self.element.find('.header').replaceWith(html.find('.overview .header'));
                self.element.find('.body').replaceWith(html.find('.content-body .overview .body'));
                if(additionalOverview) $('.additional-overview').find('.body').replaceWith(html.find('.content-body .additional-overview .body'));

                self.element.find('.pagination-toolbar').replaceWith(html.find('.overview > .pagination-toolbar').get(0));

                self.setVisibility();

                // only when we have a gclid id in the current html, do we refresh it with the value from response
                if($('.gclid-counter').length > 0) {
                    $('.gclid-counter').html(html.find('.gclid-counter').html());
                }

                setLoading('.overview', 'remove');
                if(additionalOverview) setLoading('.additional-overview', 'remove');

                makeOverviewsSortable();

            }
        });
    }

    filter()
    {   
        // console.log(this.getData());

        this.getOverviewData(
            'filters', 
            this.getData()
        );
    }

    getData() 
    {
        let data = [], 
            add,
            value,
            operator;

        this.searchbar.find('.filter-input').each(function() {

            add = true;
            operator = false;
            value = typeof $(this).val() == 'string'
                ? $(this).val().split(/\s+/).join(' ').trim().toLowerCase()
                : '';

            if ($(this).is("select")) {
                if ($(this).val() == 'all') {
                    add = false;
                } else {
                    if (typeof $(this).data('operator') !== 'undefined') {
                        operator = $(this).data('operator');
                    }
                }
            } 

            if ($(this).is("input:not(.filter-datepicker)")) {

                if ($(this).val().split(/\s+/).join(' ').trim().length < 2) {
                    add = false;
                }
            } 

            if ($(this).is("input.filter-datepicker") && typeof $(this).data('operator') !== 'undefined') {
                 
                if ($(this).val() == '') {
                    add = false;
                } else {
                    value = $(this).datepicker('getDate').getTime() / 1000;
                    operator = $(this).data('operator');
                    if (operator == '>=') {
                        operator = '>';
                    }
                    if (operator == '<=') {
                        operator = '<';
                    }

                    if (operator == '<') {
                        value += (60 * 60 * 24) - 1;
                    }

                }
            }

            if (add) {
                let obj = {
                    id: $(this).attr('id'),
                    property: $(this).data('filter-property'),
                    value: value,
                    operator: operator,
                };

                if($(this).data("subquery")) {
                    obj.subquery = $(this).data("subquery");
                }

                data.push(obj);
            }
        });

        if (data.length > 0) {
            this.searchbar.find('.btn-reset').removeClass('d-none');
        } else {
            this.searchbar.find('.btn-reset').addClass('d-none');
            return {
                'reset': true
            };
        }

        return data;
    }
}